"use client";

import { useAuth } from "@/hooks/use-auth";
import { openUserbackForm } from "@/utils/userback-loader";
import { useCallback, useState } from "react";

/**
 * Hook to open the Userback feedback form with user data
 * Handles loading state and error handling
 */
export function useUserbackFeedback() {
	const { user } = useAuth();
	const [isLoading, setIsLoading] = useState(false);

	const openFeedback = useCallback(async () => {
		if (isLoading) return;

		setIsLoading(true);
		const userData = user
			? {
					id: user.id,
					name: user.name,
					email: user.emails?.[0]?.address,
					phone: user.phones?.[0]?.number,
				}
			: undefined;

		try {
			await openUserbackForm(userData);
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error("Failed to open feedback form:", error);
		} finally {
			setIsLoading(false);
		}
	}, [isLoading, user]);

	return {
		openFeedback,
		isLoading,
	};
}
